import React from "react";
import "../styles/About.css";


const About = () => {

  return (

    <section className="about">

      <div className="terminal">


        <div className="terminal-header">


          <div className="terminal-dots">

            <span className="dot red"></span>

            <span className="dot yellow"></span>

            <span className="dot green"></span>

          </div>


          <span className="terminal-file">
            about_me.md
          </span>


        </div>



        <div className="terminal-body">


          <h2>
            👋 About Me
          </h2>



          <p>
            Hi! I'm <strong>Hooman</strong>, a 14-year-old
            self-taught software developer from Iran.
          </p>



          <p>
            I started programming because I was curious
            about how software works. I learn by building
            real projects and experimenting with new ideas.
          </p>



          <p>
            My interests include
            <span> Artificial Intelligence</span>,
            <span> Mobile Development</span>,
            <span> Computer Vision</span> and
            <span> Software Engineering</span>.
          </p>



          <p>
            Every project teaches me something new.
            I am constantly improving my skills,
            learning English, and building useful software.
          </p>



        </div>


      </div>


    </section>

  );

};


export default About;